import React, { useState } from 'react';
import axios from 'axios';
import API_BASE_URL from '../config';
import {
  Container,
  TextField,
  Button,
  Typography,
  CssBaseline,
  useMediaQuery,
} from '@mui/material';
import { useTheme, styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import LogoImage from './Logo.png'; // Adjust the path as needed

// Move styled components outside of the Login function
const LoginContainer = styled(Container)(({ theme }) => ({
  backgroundColor: '#FAF3E0',
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column', // Stack items vertically
  alignItems: 'center', // Center horizontally
  paddingTop: theme.spacing(0),
  paddingBottom: theme.spacing(2),
}));

const Logo = styled('img')(({ theme }) => ({
  width: '200px',
  height: 'auto',
  marginTop: theme.spacing(0),
  marginBottom: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    width: '150px',
  },
}));

const SubmitButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
  backgroundColor: '#333',
  color: '#FAF3E0',
  '&:hover': {
    backgroundColor: '#8D7B68',
  },
}));

function Login() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);

  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${API_BASE_URL}/auth/login`, { password });
      localStorage.setItem('token', res.data.token);
      navigate('/home'); // Navigate to home on successful login
    } catch (err) {
      setError('Invalid password');
    }
  };

  return (
    <>
      <CssBaseline />
      <LoginContainer maxWidth="sm">
        {/* Logo */}
        <Logo src={LogoImage} alt="Logo" />

        <Typography variant="body1" sx={{ marginBottom: 2, color: '#333' }}>
          Please enter your password to continue
        </Typography>
        <form onSubmit={handleLogin} style={{ width: '100%', maxWidth: '400px' }}>
          <TextField
            type="password"
            label="Password"
            variant="outlined"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            required
            sx={{ backgroundColor: '#F4ECE3', borderRadius: 1 }}
          />
          {error && (
            <Typography variant="body2" color="error" sx={{ marginTop: 1 }}>
              {error}
            </Typography>
          )}
          <SubmitButton
            type="submit"
            variant="contained"
            fullWidth
            disableElevation
          >
            Login
          </SubmitButton>
        </form>
      </LoginContainer>
    </>
  );
}

export default Login;
